interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  scrolled: boolean;
}

export default function NavLink({ to, children, scrolled }: NavLinkProps) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 relative ${
        scrolled
          ? isActive
            ? "text-primary-600"
            : "text-foreground-700 hover:text-foreground-950"
          : "text-white/90 hover:text-white"
      }`}
    >
      {children}
      {isActive && (
        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
      )}
    </Link>
  );
}